import { Enumify } from "enumify-ts";
class SenderReceiverProductCatalogueStatusType extends Enumify() {
    description;
    help;
    static DISABLED = new SenderReceiverProductCatalogueStatusType("Disabled", "No checks against the product catalogue will be performed");
    static ENABLED = new SenderReceiverProductCatalogueStatusType("Enabled", "Checks will be performed on pickup locations to ensure products are available, if the product is not available a warning will be shown");
    static ENFORCED = new SenderReceiverProductCatalogueStatusType("Enabled & Enforced", "Checks will be performed on pickup locations to ensure products are available, if the product is not available a warning will be shown and the user will not be able to select the location");
    static _ = SenderReceiverProductCatalogueStatusType._closeEnum();
    constructor(description, help) {
        super();
        this.description = description;
        this.help = help;
    }
    static selectOptionsArray() {
        return SenderReceiverProductCatalogueStatusType.values.map(it => {
            return {
                label: it.description,
                value: it.key
            };
        });
    }
}
export default SenderReceiverProductCatalogueStatusType;
